import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { smsClient } from '../client';
import type { Keyword, KeywordCreate, KeywordUpdate } from '../types';

export const keywordsAdapter: CrudAdapter<Keyword, KeywordCreate, KeywordUpdate> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await smsClient.GET('/keywords_for_replacement/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await smsClient.POST('/keywords_for_replacement/', { body: payload });
    if (error) throw error;
    return { id: data?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await smsClient.PUT('/keywords_for_replacement/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as Keyword;
  },
  async byKey(id) {
    const { data, error } = await smsClient.GET('/keywords_for_replacement/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
    return data as Keyword;
  },
  async remove(id) {
    const { error } = await smsClient.DELETE('/keywords_for_replacement/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const keywordsStore = useCrudDataSource(keywordsAdapter);
